module.exports = __webpack_public_path__ + "img/done.c1310c95.png";